var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value:
            _vm.showButton &&
            _vm.$route.name !== "submission-new-project-form" &&
            _vm.$route.name !== "submission-continue-draft-project",
          expression:
            "showButton && $route.name !== 'submission-new-project-form' && $route.name !== 'submission-continue-draft-project'"
        }
      ],
      class: [
        "back-to-top",
        {
          "modify-button-position":
            _vm.$route.name === "singleCaseWithDates" ||
            _vm.$route.fullPath.includes("?mode=")
        }
      ],
      on: {
        click: function($event) {
          return _vm.scrollToTop()
        }
      }
    },
    [
      _c("img", {
        attrs: { src: require("@/drc/assets/images/arrow-up.png"), alt: "Up" }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }